import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=691cae4e&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=ts&"
export * from "./forgetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=691cae4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cae4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691cae4e')) {
      api.createRecord('691cae4e', component.options)
    } else {
      api.reload('691cae4e', component.options)
    }
    module.hot.accept("./forgetPassword.vue?vue&type=template&id=691cae4e&scoped=true&", function () {
      api.rerender('691cae4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/userAccount/forgetPassword.vue"
export default component.exports